"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _HomepageLabelledInput = _interopRequireDefault(require("../components/HomepageLabelledInput"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _Url = _interopRequireDefault(require("PatternValidationJS/patterns/Url"));

var _InputUtil = _interopRequireDefault(require("../util/InputUtil"));

var _History = require("../util/History");

var _Paths = require("../constants/Paths");

var ErrorPageForm = function ErrorPageForm() {
  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      websiteUrl = _useState2[0],
      setWebsiteUrl = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      ignoreValidity = _useState4[0],
      setIgnoreValidity = _useState4[1];

  var isWebsiteValid = function isWebsiteValid() {
    return _Url.default.test(websiteUrl);
  };

  var buttonClicked = function buttonClicked(event) {
    // Don't ignore validity anymore
    setIgnoreValidity(false);

    if (isWebsiteValid()) {
      var parsedWebsiteUrl = _InputUtil.default.parseWebsiteUrl(websiteUrl); // Go to the results page


      (0, _History.navigateTo)(_Paths.TESTS + "/" + parsedWebsiteUrl);
    }

    event.preventDefault();
    return false;
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    return false;
  };

  var getButtonKey = function getButtonKey() {
    return 'error.form.button';
  };

  return _react.default.createElement("form", {
    className: "website-input",
    onSubmit: handleSubmit
  }, _react.default.createElement(_HomepageLabelledInput.default, {
    type: "url",
    errorText: _I18n.default.text('error.form.website.errorText'),
    labelText: _I18n.default.text('error.form.website.text'),
    onChange: function onChange(event) {
      var value = event.target.value;
      setWebsiteUrl(value);
    },
    onBlur: function onBlur(event) {
      var value = event.target.value;
      setWebsiteUrl(value.trim());
    },
    value: websiteUrl,
    isValid: function isValid() {
      return ignoreValidity || isWebsiteValid();
    }
  }), _react.default.createElement("br", null), _react.default.createElement("button", {
    className: "button primary",
    type: "submit",
    onClick: buttonClicked
  }, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: getButtonKey()
  })));
};

var _default = ErrorPageForm;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/ErrorPageForm.js
// module id = 213
// module chunks = 0